<template>
  <!-- 账号与安全 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">账号与安全</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 身份验证 -->
      <div v-if="select == '2'" class="verify">
        <div class="standing">
          <p class="standing-title">身份验证：</p>

          <div v-if="verifyData.status == '3'" class="standing-status already">
            已验证
          </div>
          <div v-else class="standing-status">
            {{
              verifyData.status == "0"
                ? "未验证"
                : verifyData.status == "1"
                ? "审核中"
                : verifyData.status == "2"
                ? "未通过"
                : verifyData.status == "5"
                ? `已解绑${nextBindTime || "--"}后可再次绑定`
                : verifyData.status == "4"
                ? "重新绑定"
                : ""
            }}
          </div>
          <span class="firm-clickable"
            style="
              font-size: 14px;
              margin-left: 15px;
              color: #409eff ;
              text-decoration: underline;
            "
            v-if="verifyData.status == '2'"
            @click="handelReason"
            >查看原因</span
          >
          <p class="Tips">
            {{
              verifyData.status == "3"
                ? "手动解绑后7天之内不可再进行重复绑定"
                : verifyData.status == "4"
                ? "用户姓名更改，需重新实名认证"
                : ""
            }}
          </p>
        </div>
        <div
          class="Click-bind firm-clickable"
          v-if="showAuthEntry"
          @click="handelAuthEntry"
        >
          <p>{{ authEntryText }}</p>
        </div>
        <div class="verified" v-else-if="verifyData.status == '1' || verifyData.status == '3'">
          <p>姓名：{{ verifyData.username }}</p>
          <p>身份证号：{{ verifyData.idCard }}</p>
          <div class="firm-clickable" v-if="verifyData.status == '3'" @click="handelVerify(4)">解绑</div>
        </div>
        <!-- <div class="standing">
          <p class="standing-title">支付密码：</p>
          <div
            v-if="verifyData.payStatus != '-1'"
            :class="
              verifyData.payStatus == 0 ? 'Switch-box' : 'Switch-box-Select'
            "
            @click="handelPayment"
          ></div>
          <p v-if="verifyData.payStatus == 1" class="open">
            开启中，购买及充值需输入支付密码
          </p>
        </div>
        <div
          v-if="verifyData.payStatus == '-1'"
          class="Click-bind firm-clickable"
          @click="handelVerify(0)"
        >
          <p>点击开启支付密码</p>
        </div>
        <div v-else class="Click-cipher">
          <div class="cipher-btn" @click="handelVerify(1)">忘记密码</div>
          <div class="cipher-btn" @click="handelVerify(2)">更换密码</div>
        </div> -->
      </div>
      <!-- 账号管理 -->
      <div v-if="select == '1'" class="manage">
        <!-- 账号信息 -->
        <div class="Account-information">
          <div class="Account-information-left">
            <p>账号信息：</p>
          </div>
          <div class="Account-information-right">
            <div class="right-box">
              <p style="margin-left: -5px; color: red">
                手机号每30天可修改1次，目前您还可以修改{{
                  AccountInformation.canModifiedPhone
                }}次
              </p>
            </div>
            <div class="right-box">
              <div class="telephone-icon"></div>
              <p>{{ AccountInformation.phone }}</p>
              <p class="switch-btn firm-clickable" @click="handelClick(0)">更换</p>
            </div>
            <div class="right-box">
              <div class="mailbox-icon"></div>
              <p>{{ AccountInformation.mail }}</p>
              <p class="switch-btn firm-clickable" @click="handelClick(1)">更换</p>
            </div>
            <div class="right-box">
              <div class="vx-icon"></div>
              <p>{{ AccountInformation.bindWx ? "微信用户" : "未绑定" }}</p>
              <p
                class="switch-btn firm-clickable"
                @click="
                  AccountInformation.bindWx
                    ? handelVxClick(4)
                    : handelVxClick(5)
                "
              >
                {{ AccountInformation.bindWx ? "解绑" : "绑定" }}
              </p>
            </div>
          </div>
        </div>
        <!-- 登录操作记录 -->
        <div class="title-box">
          <p>登录操作记录：</p>
        </div>
        <!-- 表格 -->
        <div class="tabulation">
          <RecordsTable :tableData="tableData"></RecordsTable>
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingRecords"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
        <!-- 屏蔽企业 -->
        <div class="title-box">
          <p>屏蔽企业：</p>
          <div class="title-box-btn firm-clickable" @click="handelClick(2)">添加</div>
        </div>
        <!-- 表格 -->
        <div class="tabulation">
          <ShieldTable
            :tableData="tableData1"
            :HintMsg="'暂无数据'"
            @handleEdit="handleEdit"
          ></ShieldTable>
        </div>
        <!-- 分页 -->
        <div class="paging-box">
          <div class="paging">
            <paging
              :pagingObj="pagingObj"
              @handleCurrentChange="handleCurrentChange"
            ></paging>
          </div>
        </div>
      </div>
    </div>
    <manageWin
      :dialogVisible="dialogVisible"
      :result="result"
      :PopUpTitle="PopUpTitle"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
    ></manageWin>

    <PaymentSetup
      :dialogVerify="dialogVerify"
      :distinguish="distinguish"
      :PopUpTitle="PopUpTitle"
      :verifyData="verifyData"
      @handleCloseVerify="handleCloseVerify"
      @handleUnderstandVerify="handleUnderstandVerify"
    ></PaymentSetup>

    <OneWindow
      :dialogVisible="dialogVisibleVx"
      :result="result"
      :PopUpTitle="PopUpTitle"
      :AccountInformation="AccountInformation"
      @handleClose="dialogVisibleVx = false"
      @vxUnbind="vxUnbind"
    ></OneWindow>
    <!-- 未通过原因 -->
    <ReasonWin
      :dialogReason="dialogReason"
      :Instruction="verifyData.failReason"
      :title="'未通过原因'"
      @handleCloseReason="dialogReason = false"
    ></ReasonWin>
  </div>
</template>

<script>
import ReasonWin from "../../../../firm/firmCenter/firmAccount/components/ReasonWin.vue"; //未通过原因
// 引入接口
import {
  postListShieldCompany, // 屏蔽公司列表
  postCancelShieldCompany, //删除屏蔽企业接口
  postListLoginIpLog, // 登录操作记录列表数据
  postGetIdentityAuditInfo, //身份验证-身份认证/支付密码信息页面查询
  postSwitchUserPayStatus, // 身份验证切换支付密码开关
  getUserAccountBindInfo,
  unbindUnionId,
} from "../../../../../assets/api/index";
import paging from "../../../../../components/paging.vue"; // 引入分页组件
import RecordsTable from "./components/RecordsTable.vue"; //  引入登录记录表格组件
import ShieldTable from "./components/ShieldTable.vue"; // 引入屏蔽企业表格组件
import manageWin from "./components/manageWin.vue"; // 引入更换手机号/邮箱   删除屏蔽企业添加屏蔽企业弹窗
import PaymentSetup from "./components/PaymentSetup.vue"; // 引入处理结果弹窗
import OneWindow from "../../../../firm/firmCenter/firmAccount/components/OneWindow.vue"; // 引入微信绑定解绑弹窗
export default {
  data() {
    return {
      selectArr: [
        { name: "账号管理", id: "1" },
        { name: "身份验证", id: "2" },
      ],
      select: "1", // 筛选
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
        shield: "1", // 屏蔽企业列表的分页，用于点击分页时区分
      }, // 屏蔽企业列表分页
      pagingRecords: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 操作记录列表分页
      tableData: [], // 表格数据
      tableData1: [], // 表格数据2
      verifyData: {
        status: "0", //0未验证  1审核中 2未通过 3已验证  4需重新认证
        payStatus: 0, //支付密码 1开启 0未开启
      }, // 身份是否验证，支付密码是否开启
      dialogVisible: false, //账号管理页面的总弹窗
      result: "1", // 账号管理页面 区分弹窗   0.手机号更换 1.邮箱更换 2.添加屏蔽公司  3.删除屏蔽公司
      dialogVerify: false, //身份验证页面弹窗
      distinguish: "1", // 1.开启支付密码 2.忘记/更换密码 3.点击认证身份 4.解绑
      PopUpTitle: "", //弹窗标题
      deleteId: "", // 删除屏蔽企业 需要删除的项目id
      AccountInformation: {
        phone: "",
        mail: "",
      }, // 账号信息
      dialogVisibleVx: false, //绑定解绑微信
      dialogReason: false, //查看原因
      nextBindTime: "", //计算什么时候可以重新绑定
      nextBindTimeNew: "", //
      CurrentlyTime: "", //
    };
  },
  components: {
    paging,
    RecordsTable,
    ShieldTable,
    manageWin, //账号管理页面的弹窗
    PaymentSetup, //身份验证页面的弹窗
    OneWindow,
    ReasonWin,
    //  AddDi,
    //  SwitchDi
  },
  computed: {
    // 未验证 / 未通过 / 已解绑 / 需重新认证：虚线框入口
    showAuthEntry() {
      const status = this.verifyData.status;
      return (
        status == "0" ||
        status == "2" ||
        status == "4" ||
        status == "5"
      );
    },
    authEntryText() {
      return this.verifyData.status == "2" ? "重新验证" : "点击认证身份";
    },
    // 姓名变更可立即认证；解绑需过冷却期后才可再次认证
    showRebindButton() {
      const status = this.verifyData.status;
      if (status == "4") return true;
      if (status != "5") return false;
      if (!this.nextBindTime) return true;
      return this.CurrentlyTime > this.nextBindTimeNew;
    },
  },
  // localStorage.getItem("RSA")  获取公钥
  created() {
    this.postListShieldCompany();
    this.postListLoginIpLog();
    // 身份认证 页面基本信息
    this.postGetIdentityAuditInfo();
    this.getUserAccountBindInfo();
  },
  methods: {
    // 认证入口（未通过重新验证 / 解绑重新认证走不同参数）
    handelAuthEntry() {
      const status = this.verifyData.status;
      if (status == "4" || status == "5") {
        this.handelVerify(3, 1);
      } else {
        this.handelVerify(3, 0);
      }
    },
    // 查看未通过原因
    handelReason() {
      this.dialogReason = true;
    },
    //刷新账号信息关闭弹窗
    vxUnbind() {
      this.getUserAccountBindInfo();
      this.dialogVisibleVx = false;
    },
    // 微信绑定解绑
    handelVxClick(num) {
      if (num == 4) {
        this.$confirmWithScroll("是否进行解绑?", "解绑微信", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            unbindUnionId().then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.getUserAccountBindInfo();
              }
            });
          })
          .catch(() => {});
      } else if (num == 5) {
        this.result = "5";
        this.PopUpTitle = "扫码绑定微信";
        this.dialogVisibleVx = true;
      }
    },
    // 获取账号绑定的手机号邮箱微信
    getUserAccountBindInfo() {
      getUserAccountBindInfo().then((res) => {
        if (res.code == 0) {
          this.AccountInformation = res.data;
        }
      });
    },
    // -----------------------身份验证-身份认证/支付密码信息页面查询-------------
    async postGetIdentityAuditInfo() {
      var data = {
        data: {},
      };
      // 调用 身份认证页面基础信息接口
      const res = await postGetIdentityAuditInfo(data);
      console.log(res, "verifyData");
      this.verifyData = res.data;
      this.CurrentlyTime = Date.now();
      if (this.verifyData.nextBindTime) {
        this.nextBindTime = this.verifyData.nextBindTime;
        this.nextBindTimeNew = new Date(this.verifyData.nextBindTime).getTime();
      } else {
        this.nextBindTime = "";
        this.nextBindTimeNew = 0;
      }
    },

    // 日期格式化：yyyy-MM-dd HH:mm:ss
    formatDate(date) {
      // 增加类型校验，防止非 Date 对象传入
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error("formatDate 传入的不是有效日期对象:", date);
        return ""; // 或返回默认值
      }
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const d = date.getDate().toString().padStart(2, "0");
      const hh = date.getHours().toString().padStart(2, "0");
      const mm = date.getMinutes().toString().padStart(2, "0");
      const ss = date.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    // ----------------------------屏蔽企业 列表数据 ---------------------
    async postListShieldCompany() {
      var data = {
        data: {},
      };
      const res = await postListShieldCompany(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        // 屏蔽企业列表数据获取成功
        this.tableData1 = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      } else {
        // 数据获取失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // ---------------------------- 登录操作记录  列表数据 ---------------------------
    postListLoginIpLog() {
      var data = {
        data: {},
      };
      // 调用 登录操作记录数据接口
      postListLoginIpLog(
        data,
        this.pagingRecords.currentPage,
        this.pagingRecords.pageSize
      ).then((res) => {
        if (res.code == 0) {
          // 屏蔽企业列表数据获取成功
          this.tableData = res.data.list;
          this.pagingRecords.totalDevice = res.data.total;
        } else {
          // 数据获取失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 身份验证页面弹窗 1开启支付密码  2忘记/更换密码
    handelVerify(num, num1) {
      if (num == 0) {
        this.distinguish = "0";
        this.PopUpTitle = "开启支付密码";
        this.dialogVerify = true;
      } else if (num == 1) {
        this.distinguish = "1";
        this.PopUpTitle = "忘记密码";
        this.dialogVerify = true;
      } else if (num == 2) {
        this.distinguish = "1";
        this.PopUpTitle = "更换密码";
        this.dialogVerify = true;
      } else if (num == 3) {
        if (num1 == 1 && !this.showRebindButton) {
          this.$tool.PromptBox(
            "warning",
            `请在${this.nextBindTime || "--"}以后进行身份认证`
          );
          return;
        }
        this.dialogVerify = true;
        this.distinguish = "3";
        this.PopUpTitle = "认证身份";
      } else if (num == 4) {
        this.distinguish = "4";
        this.PopUpTitle = "解绑";
        this.dialogVerify = true;
      }
    },
    // 身份验证弹窗 关闭
    handleCloseVerify(val) {
      this.dialogVerify = !this.dialogVerify;
    },
    //身份验证弹窗 确认
    handleUnderstandVerify(val) {
      this.postGetIdentityAuditInfo();
      this.dialogVerify = !this.dialogVerify;
    },

    // 账号管理页更换手机号/更换邮箱  0.手机号更换 1.邮箱更换 2.添加屏蔽公司  3.删除屏蔽公司
    handelClick(num) {
      if (num == 0) {
        if (this.AccountInformation.canModifiedPhone == 0) {
          this.$tool.PromptBox("warning", "本月已无可修改次数");
        } else {
          this.result = "0";
          this.PopUpTitle = "手机号更换";
          this.dialogVisible = true;
        }
      } else if (num == 1) {
        this.result = "1";
        this.PopUpTitle = "电子邮箱更换";
        this.dialogVisible = true;
      } else if (num == 2) {
        this.result = "2";
        this.PopUpTitle = "添加屏蔽企业";
        this.dialogVisible = true;
      }
    },
    // 屏蔽公司表格中的 删除
    handleEdit(index, row) {
      this.deleteId = row.id;
      this.$confirmWithScroll("确认删除对该公司的屏蔽?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postCancelShieldCompany({
            data: {
              id: this.deleteId,
            },
          }).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.postListShieldCompany();
            }
          });
        })
        .catch(() => {});
    },
    // 账号管理页的弹窗关闭
    handleClose(val) {
      this.dialogVisible = !this.dialogVisible;
    },
    // 账号管理页的弹窗确认
    handleUnderstand(val) {
      if (val == 2) {
        // 添加屏蔽企业 刷新屏蔽企业数据接口
        this.postListShieldCompany();
      } else if (val == 3) {
        // 删除屏蔽企业
        var data = {
          data: {
            id: this.deleteId,
          },
        };
        postCancelShieldCompany(data).then((res) => {
          if (res.code == 0) {
            // 删除成功 刷新数据列表
            this.postListShieldCompany();
            this.$tool.PromptBox("success", "操作成功");
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      }
      this.getUserAccountBindInfo();
      this.dialogVisible = !this.dialogVisible;
    },
    // 支付密码 滑块
    handelPayment() {
      var data = {};
      data.data = {
        userId: this.$store.getters.getUser.id,
        payStatus: this.verifyData.payStatus == "0" ? "1" : "0",
      };
      // 调用 身份验证切换支付密码开关
      postSwitchUserPayStatus(data).then((res) => {
        if (res.code == 0) {
          this.verifyData.payStatus = !this.verifyData.payStatus;
        } else {
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 筛选
    handelSelect(num) {
      this.select = num;
      // this.$emit("handelSelect", num);
    },

    // 分页
    handleCurrentChange(val, pagingObj) {
      // 屏蔽企业表格分页
      if (pagingObj.shield) {
        this.pagingObj.currentPage = val;
        this.postListShieldCompany();
      } else {
        // 登录操作记录表格分页
        this.pagingRecords.currentPage = val;
        this.postListLoginIpLog();
      }
    },
  },
};
</script>

<style scoped lang="less">
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-top: 13px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    // 切换
    .Toggle {
      width: 100%;
      height: 30px;
      display: flex;
      color: #333333;
      text-align: center;
      font-weight: 400;
      p:nth-child(1) {
        margin-left: 20px;
      }
      p {
        margin-right: 40px;
        font-size: 16px;
        cursor: pointer;
      }
      .select-p {
        color: #409eff ;
        box-sizing: border-box;
        border-bottom: 2px solid #409eff ;
      }
    }
    // 身份验证
    .verify {
      width: 100%;
      min-height: 30px;
      margin-top: 50px;
      .standing {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        .standing-title {
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #333333;
          font-weight: 400;
        }
        .standing-status {
          min-width: 50px;
          height: 30px;
          padding: 0px 5px;
          background: #eeeeee;
          border: 1px solid #999999;
          border-radius: 5px;
          font-size: 12px;
          color: #333333;
          text-align: center;
          font-weight: 400;
          margin-left: 15px;
        }
        .Tips {
          font-size: 12px;
          color: #f5a854;
          margin-left: 20px;
        }
        .already {
          background: #ffffff;
          border: 1px solid #95ec6a;
        }
        .open {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          line-height: 35px;
          color: #333333;
          font-weight: 400;
          margin-left: 40px;
        }
        .Switch-box {
          width: 60px;
          height: 30px;
          margin-left: 15px;
          border-radius: 10px;
          background-image: url("../../../../../assets/imgs/weikaiqi@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .Switch-box-Select {
          width: 60px;
          height: 30px;
          margin-left: 15px;
          border-radius: 10px;
          background-image: url("../../../../../assets/imgs/kaiqi@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      // 已验证
      .verified {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin-bottom: 50px;
        margin-top: 30px;
        display: flex;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          margin-right: 50px;
        }
        div {
          min-width: 45px;
          height: 20px;
          background: #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          font-weight: 400;
          cursor: pointer;
          padding: 0px 10px;
        }
      }
      //已开启支付密码
      .Click-cipher {
        width: 100%;
        height: 30px;
        line-height: 30px;
        display: flex;
        margin-bottom: 50px;
        margin-top: 30px;
        .cipher-btn {
          width: 85px;
          height: 30px;
          background: #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          font-weight: 400;
          margin-right: 30px;
          cursor: pointer;
        }
      }
      // 未绑定/未开启支付密码
      .Click-bind {
        width: 100%;
        height: 50px;
        line-height: 50px;
        border: 1px dashed #409eff ;
        margin-bottom: 50px;
        margin-top: 30px;
        display: flex;
        border-radius: 5px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        p {
          width: 100%;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    // 账号管理
    .manage {
      width: 100%;
      min-height: 30px;
      margin-top: 30px;
      // border: 1px solid gold;
      display: flex;
      flex-direction: column;
      // 账号信息
      .Account-information {
        min-width: 550px;
        // height: 110px;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        margin-right: auto;
        display: flex;
        padding-bottom: 20px;
        .Account-information-left {
          min-width: 100px;
          height: 100%;
          margin-left: 20px;
          margin-right: 10px;
          p {
            height: 20px;
            line-height: 20px;
            margin-top: 23px;
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #333333;
            font-weight: 400;
          }
        }
        .Account-information-right {
          flex: 1;
          height: 100%;
          .right-box {
            width: 100%;
            height: 20px;
            line-height: 20px;
            margin-top: 25px;
            display: flex;
            .telephone-icon {
              width: 20px;
              height: 20px;
              background-image: url("../../../../../assets/imgs/dianhua-weijiaohuan@3x.svg");
              background-size: 100% 100%;
            }
            .mailbox-icon {
              margin: auto 0;
              width: 20px;
              height: 15px;
              background-image: url("../../../../../assets/imgs/youxiang@3x.svg");
              background-size: 100% 100%;
            }
            .vx-icon {
              width: 20px;
              height: 20px;
              background-image: url("../../../../../assets/imgs/weixin-weijiaohuan@3x.svg");
              background-size: 100% 100%;
            }
            p {
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #333333;
              font-weight: 400;
              margin-left: 10px;
            }
            .switch-btn {
              width: 45px;
              height: 20px;
              background: #409eff ;
              border-radius: 5px;
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #ffffff;
              font-weight: 400;
              text-align: center;
              margin-left: 40px;
              cursor: pointer;
            }
          }
        }
      }
      // 登录操作记录
      .title-box {
        width: 100%;
        height: 35px;
        line-height: 35px;
        margin-top: 30px;
        margin-bottom: 20px;
        display: flex;
        position: relative;
        p {
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #333333;
          font-weight: 400;
          min-width: 200px;
        }
        .title-box-btn {
          position: absolute;
          right: 0;
          width: 75px !important;
          height: 35px;
          background: #409eff ;
          border-radius: 5px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          font-weight: 400;
          text-align: center;
          cursor: pointer;
        }
      }
      // 表格
      .tabulation {
        width: 100%;
        min-height: 200px;
        box-sizing: border-box;
      }
      // 分页
      .paging-box {
        width: 100%;
        height: 22px;
        margin-top: 30px;
        display: flex;
        justify-content: flex-end;
        .paging {
          width: 90%;
          height: 100%;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
